import { FC } from 'react';
import { CardBodyProps } from './types';
import { styleCardBody } from './style';
import clsx from 'clsx';

const CardBody: FC<CardBodyProps> = (props) => {
  const { className, children, ...rest } = props;

  const cls = styleCardBody(props);
  return (
    <div className={clsx(cls.main, className)} {...rest}>
      {children}
    </div>
  );
};

export default CardBody;
